module.exports = __webpack_public_path__ + "img/5-1.8d375487.svg";